// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"fcad0b6a","598":"bfaa79a2","963":"abf7c720"}[chunkId] + ".chunk.js";
};